export default __webpack_public_path__ + "static/media/2159.01aa71b5.png";